import { MeldType, type TMeldType } from './meld';

/** 對局中的 UI 與 AI 共用同一可見資訊規則。 */
export const isMeldKindVisible = (type: TMeldType, isOwnHand: boolean): boolean =>
  isOwnHand || type !== MeldType.KongConcealed;
